namespace Areas.Vendor {
    "use strict";

    let vendorOwnerStatusId: number;


    var selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Vendor/User/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function newVendorUser(e) {
        var dataGrid = $('#UserGrid').dxDataGrid('instance');
        var vendorId = dataGrid.option('VendorId');
                                                               
        e.data.vendorId = vendorId;
    }


    export function saveProfile() {
        const form = $("#VendorProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Vendor/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT", (data) => { Areas.reloadPage(); });
        }
    }


    export function onAddInsuranceRecord(e) {
        var dataGrid = $('#InsuranceGrid').dxDataGrid('instance');
        var vendorId = dataGrid.option('VendorId');

        e.data.vendorId = vendorId;
    }

    export function onAddExperienceRecord(e) {
        var dataGrid = $('#ExperienceGrid').dxDataGrid('instance');
        var vendorId = dataGrid.option('VendorId');

        e.data.vendorId = vendorId;
        e.data.isOSHPD = false;
    }

    export function printVendorInfo() {
        window.alert("Print this Vendor Form ... Under Development");
    }

    export function showCreate() {
        $("#CreateVendorPopup").dxPopup("instance").show();
    }

    export function showMissingInfoPopup() {
        $("#VendorMissingInfoPopup").dxPopup("instance").show();
    }

    export function closePopup() {
        $("#VendorMissingInfoPopup").dxPopup("instance").hide();
    }

}
